<template>
    <a v-bind:href="link"
        v-bind:target="external ? '_blank' : null"
        v-bind:rel="external ? 'noopener' : null"
        class="widget-apps-item">
        <div class="widget-apps-img">
            <img v-if="!imageError" v-bind:src="image" v-bind:alt="name" v-on:error="imageError = true" />
            <icon-broken-image v-else class="widget-apps-img__broken" />
        </div>
        <div class="widget-apps-content">
            <div class="widget-apps-name">{{ name }}</div>
            <div class="widget-apps-description">{{ currentDescription }}</div>
        </div>
    </a>
</template>

<script>
import { mapState } from 'vuex';
import IconBrokenImage from '@img/icons/tonscan/image-broken.svg?vue';

export default {
    props: {
        name: String,
        image: String,
        description_en: String,
        description_ru: String,
        link: String,
        external: Boolean,
    },

    data() {
        return {
            imageError: false,
        };
    },

    computed: {
        ...mapState({ appsLanguage: 'appLocale' }),
        currentDescription() {
            return this.$i18n.locale === 'ru' ? this.description_ru : this.description_en;
        },
    },

    components: {
        IconBrokenImage,
    },
};
</script>

<style lang="scss">
.widget-apps-img__broken {
    display: block;
    width: 100%;
    aspect-ratio: 1;
    padding: 12px;
    box-sizing: border-box;
    background: var(--ui-round-image-color);
    color: var(--body-muted-text-color);
}
</style>
